import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import options from './constants/options';
import optionLabels from './constants/labels';
import mapOptionToValue from './constants/map-option-to-value';

import './sort-type-switcherd.css';

export const optionsKeys = Object.keys(options);

class SortTypeSwitcher extends PureComponent
{
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool
  };

  static defaultProps = {
    isDisabled: false
  };

  constructor(props)
  {
    super(props);
    this.state = { value: options.NAME_ASC };
  }

  handleChange = ({ target: { value } }) =>
  {
    const { onChange } = this.props;
    this.setState({ value });
    onChange(value, mapOptionToValue[value]);
  };

  render()
  {
    const { isDisabled } = this.props;
    const { value } = this.state;

    return (
      <div className="resource-dialog__sort-type-switcher-container">
        <div className="resource-dialog__sort-type-switcher">
          <select onChange={this.handleChange} value={value} disabled={isDisabled}>
            {optionsKeys.map(option => (
              <option value={options[option]} key={`sort-option-${options[option]}`}>
                {optionLabels[option]}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }
}

export default SortTypeSwitcher;